import { Link, useParams } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { ArrowLeft, ArrowRight, Calendar1, Clock, Plus } from "lucide-react";
import hostIcon from "../images/hostIcon.svg";
import attendeesImg from "../images/attendees.png";
import checkImg from "../images/check.svg";
import EventCarousel from "./eventCarousel";
import { EventCard } from "./Events";
import { fetchEventDetails, fetchEvents } from "../Service/api";
import { useQuery } from "@tanstack/react-query";
import { ClipLoader } from "react-spinners";
import moment from "moment";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
// This is crucial for fixing the default marker icon issue
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { useModal } from "./DownloadModalContext";
import Title from "./Title";

function EventDetail() {
  let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  L.Marker.prototype.options.icon = DefaultIcon;

  const { eventId } = useParams();

  const {
    data: eventDetailsData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["eventsDetails", eventId],
    queryFn: () => fetchEventDetails(eventId),
  });

  const { openModal } = useModal();

  const eventDetails = eventDetailsData?.data;

  const { data: otherEvents, isError: isOtherError } = useQuery({
    queryKey: ["events"],
    queryFn: () => fetchEvents(),
  });

  const filterEventsExcludingId = otherEvents?.data?.data.filter(
    (event) => event.id !== +eventId
  );

  const formatFollowerNumber = (num) => {
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "m";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "k";
    return num.toString();
  };

  const lat = eventDetails?.latitude;
  const lng = eventDetails?.longitude;

  if (isError) {
    return (
      <>
        <Header />
        <div className="web-max-container" style={{ marginTop: "25px" }}>
          <h1 style={{ textAlign: "center" }}>Something went wrong</h1>
        </div>
      </>
    );
  }

  return (
    <div>
      <Title title={eventDetails?.event_name || "Events | Palynx"} />
      <Header />
      <div className="web-max-container" style={{ marginTop: "8px" }}>
        <Link
          to="/events"
          style={{
            textDecoration: "none",
            width: "56px",
            height: "56px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "white",
            borderRadius: "100%",
            color: "#101828",
          }}
        >
          <ArrowLeft />
        </Link>
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "60vh",
              marginTop: "80px",
            }}
          >
            <ClipLoader color="#36d7b7" size={50} />
          </div>
        ) : (
          <>
            {" "}
            <div
              className="details__events__cont"
              style={{ marginTop: "16px", fontFamily: '"Rubik", sans-serif' }}
            >
              <div className="__details__cont">
                <div>
                  <EventCarousel slides={eventDetails?.event_images} />
                </div>
                <div>
                  <h2 className="deets__title">{eventDetails?.event_name}</h2>
                  <h4
                    style={{
                      color: "#1D1D1B",
                      fontWeight: "400",
                      fontSize: "16px",
                      margin: "16px 0 12px",
                    }}
                  >
                    Details
                  </h4>
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#67655E",
                      fontWeight: "400",
                      lineHeight: "20px",
                      margin: "0",
                    }}
                  >
                    {eventDetails?.details}
                  </p>
                  {eventDetails?.hash_tags && (
                    <div className="hashtag__cont ">
                      <p>#{eventDetails?.hash_tags}</p>
                    </div>
                  )}
                  <div className="host__details__cont">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                        width: "100%",
                        gap: "12px",
                        padding: "0 16px 20px",
                        borderBottom: "solid 1px #F9F6F3",
                      }}
                    >
                      <div className="host-img-cont">
                        {eventDetails?.user?.profile_picture ? (
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "100%",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <img
                              src={eventDetails?.user?.profile_picture}
                              alt="user img"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          </div>
                        ) : (
                          <img src={hostIcon} alt="host icon" />
                        )}
                        <div>
                          <h3>{eventDetails?.user?.username}</h3>
                          {eventDetails?.user.followers_count && (
                            <p>
                              {formatFollowerNumber(
                                eventDetails?.user.followers_count
                              )}{" "}
                              {eventDetails?.user.followers_count > 1
                                ? "Followers"
                                : "Follower"}
                            </p>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={openModal}
                        className="event__follow__btn"
                      >
                        <p style={{ margin: "0" }}>Follow</p>{" "}
                        <Plus width={18} height={18} />
                      </button>
                    </div>
                    <EventTime
                      time={eventDetails?.event_dates[0].time}
                      datetime={eventDetails?.event_dates[0].event_date}
                    />
                  </div>

                  <div className="fee__cont">
                    <div>
                      {eventDetails?.event_type_id !== 3 && <p>fee</p>}
                      {eventDetails?.event_type_id === 2 ? (
                        <h4>${eventDetails?.price}</h4>
                      ) : eventDetails?.event_type_id === 3 ? (
                        <h4>Book your spot now</h4>
                      ) : (
                        <h4>Free</h4>
                      )}
                    </div>

                    {eventDetails?.event_type_id !== 1 ? (
                      eventDetails?.event_type_id === 2 ? (
                        <button onClick={openModal}>Book a spot</button>
                      ) : (
                        <a
                          href={eventDetails?.request_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Book a spot
                        </a>
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="details__events__cont"
              style={{ marginTop: "32px", fontFamily: '"Rubik", sans-serif' }}
            >
              <div className="location__info__cont">
                <div className="location__info">
                  <div className="attendees__cont">
                    <div onClick={openModal} className="attend__card">
                      <h3>Attendees</h3>
                      <div>
                        <img src={attendeesImg} alt="attendees" />
                        <ArrowRight strokeWidth={1.5} />
                      </div>
                    </div>
                    <div onClick={openModal} className="attend__card">
                      <h3>Conversations</h3>
                      <div>
                        <p
                          style={{
                            fontSize: "13px",
                            color: "#67655E",
                            fontWeight: "400",
                            margin: "0",
                          }}
                        >
                          Chat with other attendees
                        </p>
                        <ArrowRight strokeWidth={1.5} />
                      </div>
                    </div>
                  </div>
                  <div className="local__highlights">
                    {eventDetails?.require_info && (
                      <>
                        {" "}
                        <h3
                          style={{
                            margin: "0 0 16px",
                            fontSize: "16px",
                            color: "#1D1D1B",
                            fontWeight: "600",
                          }}
                        >
                          Requirements and Additional Information
                        </h3>
                        <div className="_gear">
                          <img src={checkImg} alt="check icon" />
                          <p>{eventDetails?.require_info}</p>
                        </div>
                      </>
                    )}
                    <p
                      className="mt-4"
                      style={{
                        fontSize: "16px",
                        color: "#E66C11",
                        fontWeight: "400",
                        margin: "24px 0 0 0",
                      }}
                    >
                      For additional enquiries, please contact the organizer.
                    </p>
                  </div>
                </div>
                <div className="location__map">
                  <div className="map__card">
                    <div className="map__cont">
                      <MapContainer
                        center={[lat, lng]}
                        zoom={13}
                        style={{ height: "100%", width: "100%" }}
                      >
                        <TileLayer
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={[lat, lng]}>
                          <Popup>
                            Location: {lat}, {lng}
                          </Popup>
                        </Marker>
                      </MapContainer>
                    </div>
                    <div>
                      <h3
                        style={{
                          margin: "20px 0 5px",
                          color: "#1D1D1B",
                          fontSize: "20px",
                        }}
                      >
                        {eventDetails?.address}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {filterEventsExcludingId && !isOtherError && (
              <div
                style={{ marginTop: "42px", fontFamily: '"Rubik", sans-serif' }}
              >
                <h2
                  style={{
                    fontSize: "24px",
                    margin: "0",
                    fontWeight: "700",
                    color: "#1D1D1B",
                  }}
                >
                  You also might be interested in
                </h2>
                <div
                  style={{ marginTop: "18px" }}
                  className="events__card__cont"
                >
                  {filterEventsExcludingId.length ? (
                    filterEventsExcludingId
                      .slice(0, 3)
                      .map((eventDetails, index) => (
                        <EventCard
                          id={eventDetails?.id}
                          key={index}
                          title={eventDetails?.event_name}
                          place={eventDetails?.address}
                          date={eventDetails?.event_dates[0].event_date}
                          time={eventDetails?.event_dates[0].time}
                          tag={eventDetails?.hash_tags}
                          img={eventDetails?.event_images[0]?.event_image_url}
                        />
                      ))
                  ) : (
                    <h3 style={{ textAlign: "center" }}>No Events Found</h3>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

const EventTime = ({ datetime, time }) => {
  const formattedDate = moment(datetime).format("DD MMMM YYYY"); // "11 March 2024"

  return (
    <div className="event__time__cont">
      <div className="_time__date">
        <Calendar1 strokeWidth={1.5} width={20} height={20} />
        <p>{formattedDate}</p>
      </div>
      <div className="_time__date">
        <Clock strokeWidth={1.5} width={20} height={20} />
        <p>{time}</p>
      </div>
    </div>
  );
};

export default EventDetail;
